import { serverLogger } from "~/logger.server";

export const createAuthState = ({
	redirectTo,
}: {
	redirectTo?: string;
}) => {
	if (!redirectTo) {
		return undefined;
	}
	return JSON.stringify({ redirectTo });
};

export const parseAuthState = (state: string | null) => {
	if (!state) {
		return { redirectTo: null };
	}
	try {
		const parsed = JSON.parse(state);
		return { redirectTo: parsed.redirectTo || null };
	} catch (e) {
		serverLogger.error("Failed to parse state", e instanceof Error ? e : new Error("Unknown Error"), {
			logGroup: "WORKOS_ERROR",
			state,
		});
		return { redirectTo: null };
	}
};
